<template>
  <v-container fluid class="top-image" style="background: linear-gradient(#043339, #fff);">
    <!-- DESKTOP (>= lg) -->
    <template v-if="lgAndUp">
      <v-row class="mx-16 px-16 py-16 mt-16">
        <v-col cols="12" lg="6">
          <v-row>
            <v-col cols="12" class="text-center">
              <span class="text-h3 text-white font-weight-medium">{{ $t('footer.ideas1') }}</span>
            </v-col>
            <v-col cols="12" class="text-center">
              <span class="text-h4 text-white font-weight-medium">{{ $t('footer.ideas2') }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title style="background-color:#094A59" class="text-white">
                  <v-icon color="white" class="mr-2">mdi-message</v-icon>{{ $t('footer.send') }}
                </v-card-title>

                <v-card-text>
                  <Form @submit="submit" v-slot="{ errors, isSubmitting }" :class="{ shake: animated }">
                    <fieldset :disabled="loading || isSubmitting">
                      <v-card class="elevation-0">
                        <v-card-title class="yellow-back">
                          <span class="text-white text-subtitle-1 font-weight-bold">
                            <v-icon :size="18" color="white" class="mr-2">mdi-comment</v-icon>{{ $t('CONTACTS.NEW_MESSAGE') }}
                          </span>
                        </v-card-title>

                        <v-card-text>
                          <v-row class="mt-n16">
                            <v-col cols="12">
                              <Field name="name" :rules="'required'" v-slot="{ field }">
                                <v-text-field
                                  v-bind="field"
                                  v-model="fields.name"
                                  :label="$t('CONTACTS.NAME')"
                                  class="font-weight-bold"
                                  :error-messages="errors.name ? [errors.name] : []"
                                />
                              </Field>
                            </v-col>

                            <v-col cols="12">
                              <Field name="email" :rules="'required|email'" v-slot="{ field }">
                                <v-text-field
                                  v-bind="field"
                                  v-model="fields.email"
                                  label="Email"
                                  class="font-weight-bold"
                                  :error-messages="errors.email ? [errors.email] : []"
                                />
                              </Field>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="fields.company"
                                :label="$t('CONTACTS.EMPRESA')"
                                class="font-weight-bold"
                              />
                            </v-col>

                            <v-col cols="12" md="6">
                              <Field name="numero" :rules="'required'" v-slot="{ field }">
                                <v-text-field
                                  v-bind="field"
                                  v-model="fields.numero"
                                  :label="$t('CONTACTS.NUMERO')"
                                  class="font-weight-bold"
                                  :error-messages="errors.numero ? [errors.numero] : []"
                                />
                              </Field>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="fields.country"
                                :items="countries"
                                item-title="nome"
                                item-value="nome"
                                :label="$t('CONTACTS.PAIS')"
                                class="font-weight-bold"
                              />
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="fields.size"
                                :items="size_company[$i18n.locale]"
                                :label="$t('CONTACTS.SIZE')"
                                class="font-weight-bold"
                              />
                            </v-col>

                            <v-col cols="12" v-if="false">
                              <Field name="title" :rules="'required'" v-slot="{ field }">
                                <v-text-field
                                  v-bind="field"
                                  v-model="fields.title"
                                  :label="$t('CONTACTS.TITLE')"
                                  class="font-weight-bold"
                                  :error-messages="errors.title ? [errors.title] : []"
                                />
                              </Field>
                            </v-col>

                            <v-col cols="12">
                              <v-textarea
                                v-model="fields.description"
                                :label="$t('CONTACTS.DESCRIPTION')"
                                rows="2"
                                class="font-weight-bold"
                              />
                            </v-col>

                            <!-- reCAPTCHA (desktop) -->
                            <v-col cols="12">
                              <div ref="rcDesktop" class="my-4"></div>
                            </v-col>
                          </v-row>
                        </v-card-text>

                        <v-card-actions>
                          <v-row align="center" justify="space-around">
                            <v-col align="center">
                              <v-btn
                                type="submit"
                                :disabled="!recaptchaOk"
                                :loading="isSubmitting"
                                variant="flat"
                                color="#052947"
                                class="mr-5 ml-5 font-weight-bold text-white"
                              >
                                {{ $t('CONTACTS.SEND') }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </fieldset>
                  </Form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!-- DECOR à direita (polígonos) -->
        <div style="z-index:0 !important; position:absolute; bottom:0; right:0; height:85%; width:50%;">
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(27% 17%,14% 34%,28% 32%); width:100%; background-color:#EF9576; z-index:3;"></div>
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(54% 2%,45% 24%,58% 24%); width:100%; background-color:#14545B; z-index:3;"></div>
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(66% 36%,75% 41%,76% 34%); width:100%; background-color:#0D1F2B; z-index:3;"></div>
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(23% 91%,35% 92%,31% 77%); width:100%; background-color:#E76012; z-index:3;"></div>
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(10% 80%,23% 81%,20% 68%); width:100%; background-color:#fff; z-index:3;"></div>
          <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(26% 0,100% 54%,100% 75%,35% 100%,9% 100%); width:100%; background-color:#052947; z-index:2;">
            <div style="width:50%; height:50%; position:relative; top:60%; transform:translate(50%,-50%);" class="text-white">
              <v-row style="display:block; margin:auto;">
                <v-col cols="12" class="text-h4">{{ $t('PRE_FOOTER.contacts') }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="auto"><v-icon color="white">mdi-email</v-icon></v-col>
                <v-col cols="12" md="auto" class="font-weight-light text-h6">info@dreamdealtech.com</v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="auto"><v-icon color="white">mdi-clock</v-icon></v-col>
                <v-col cols="12" md="auto" class="font-weight-light text-h6">{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="auto"><v-icon color="white">mdi-phone</v-icon></v-col>
                <v-col cols="12" md="auto" class="font-weight-light text-h6">(+351) 220 280 430</v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-row>

      <!-- canto superior decor -->
      <div class="d-none d-lg-block" style="position:absolute; top:0; right:0; height:300px; width:350px;">
        <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(86% 16%,96% 22%,98% 8%); width:100%; background-color:#0D1F2B; z-index:3;"></div>
        <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(60% 14%,75% 53%,99% 29%); width:100%; background-color:#fff; z-index:3;"></div>
        <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(77% 69%,88% 78%,91% 55%); width:100%; background-color:#063F57; z-index:3;"></div>
        <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(12% 0,21% 0,29% 29%,0 28%,12% 0); width:100%; background-color:#052947; z-index:3;"></div>
      </div>
    </template>

    <!-- MOBILE (< lg) -->
    <template v-else>
      <!-- Formulário em cima -->
      <v-row class="mx-2 px-2 pt-10 mt-10">
        <v-col cols="12">
          <v-card>
            <v-card-title style="background-color:#094A59" class="text-white text-caption">
              <v-icon color="white" class="mr-2">mdi-message</v-icon>{{ $t('footer.send') }}
            </v-card-title>
            <v-card-text>
              <Form @submit="submit" v-slot="{ errors, isSubmitting }" :class="{ shake: animated }">
                <fieldset :disabled="loading || isSubmitting">
                  <v-card class="elevation-0">
                    <v-card-title class="yellow-back">
                      <span class="text-white text-subtitle-1 font-weight-bold">
                        <v-icon :size="18" color="white" class="mr-2">mdi-comment</v-icon>{{ $t('CONTACTS.NEW_MESSAGE') }}
                      </span>
                    </v-card-title>
                    <v-card-text class="text-caption">
                      <v-row>
                        <v-col cols="12">
                          <Field name="name_m" :rules="'required'" v-slot="{ field }">
                            <v-text-field v-bind="field" v-model="fields.name" :label="$t('CONTACTS.NAME')"
                                          class="font-weight-bold" :error-messages="errors.name_m ? [errors.name_m] : []" />
                          </Field>
                        </v-col>

                        <v-col cols="12">
                          <Field name="email_m" :rules="'required|email'" v-slot="{ field }">
                            <v-text-field v-bind="field" v-model="fields.email" label="Email"
                                          class="font-weight-bold" :error-messages="errors.email_m ? [errors.email_m] : []" />
                          </Field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field v-model="fields.company" :label="$t('CONTACTS.EMPRESA')" class="font-weight-bold" />
                        </v-col>

                        <v-col cols="12" md="6">
                          <Field name="numero_m" :rules="'required'" v-slot="{ field }">
                            <v-text-field v-bind="field" v-model="fields.numero" :label="$t('CONTACTS.NUMERO')"
                                          class="font-weight-bold" :error-messages="errors.numero_m ? [errors.numero_m] : []" />
                          </Field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-autocomplete v-model="fields.country" :items="countries" item-title="nome" item-value="nome"
                                          :label="$t('CONTACTS.PAIS')" class="font-weight-bold" />
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-autocomplete v-model="fields.size" :items="size_company[$i18n.locale]"
                                          :label="$t('CONTACTS.SIZE')" class="font-weight-bold" />
                        </v-col>

                        <v-col cols="12">
                          <v-textarea v-model="fields.description" :label="$t('CONTACTS.DESCRIPTION')" rows="2"
                                      class="font-weight-bold" />
                        </v-col>

                        <!-- reCAPTCHA (mobile) -->
                        <v-col cols="12">
                          <div ref="rcMobile" class="my-4"></div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-row align="center" justify="center">
                        <v-col align="center">
                          <v-btn type="submit" :disabled="!recaptchaOk" :loading="isSubmitting" variant="flat" color="#052947"
                                 class="mr-5 ml-5 font-weight-bold text-white">
                            {{ $t('CONTACTS.SEND') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </fieldset>
              </Form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Contactos em baixo (polígono grande) -->
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <div style="position:relative; min-height:70vh;">
            <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(27% 17%,14% 34%,28% 32%); width:100%; background:#EF9576; z-index:1;"></div>
            <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(54% 2%,45% 24%,58% 24%); width:100%; background:#14545B; z-index:1;"></div>
            <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(66% 36%,75% 41%,76% 34%); width:100%; background:#0D1F2B; z-index:1;"></div>
            <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(23% 91%,35% 92%,31% 77%); width:100%; background:#E76012; z-index:1;"></div>
            <div style="position:absolute; bottom:0; height:100%; clip-path:polygon(10% 60%,13% 71%,20% 58%); width:100%; background:#fff; z-index:1;"></div>

            <div style="position:absolute; inset:0; clip-path:polygon(26% 0,100% 54%,100% 75%,35% 100%,9% 100%); background:#052947; z-index:2;">
              <div style="width:85%; max-width:520px; margin:0 auto; position:absolute; left:50%; top:55%;
                          transform:translate(-50%,-50%);" class="text-white text-center">
                <div class="text-h6 font-weight-bold mb-4">{{ $t('PRE_FOOTER.contacts') }}</div>
                <div class="mb-2"><v-icon :size="16" color="white" class="mr-2">mdi-email</v-icon>info@dreamdealtech.com</div>
                <div class="mb-2"><v-icon :size="16" color="white" class="mr-2">mdi-clock</v-icon>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</div>
                <div><v-icon :size="16" color="white" class="mr-2">mdi-phone</v-icon>(+351) 220 280 430</div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Form, Field, defineRule, configure } from 'vee-validate'
import { required, email } from '@vee-validate/rules'
import { useDisplay } from 'vuetify'
import { sendContact } from '@/api/EmailService.js'

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// breakpoints
const { lgAndUp } = useDisplay()

// vee-validate
defineRule('required', required)
defineRule('email', email)
configure({ validateOnInput: true })

const { t } = useI18n({ useScope: 'global' })
const router = useRouter()

const loading = ref(true)
const animated = ref(false)
const fields = reactive({
  name: null,
  company: null,
  numero: null,
  country: 'Portugal',
  size: null,
  email: null,
  title: null,
  description: null,
})

const size_company = {
  pt: ['< 5 empregados', '5 - 20 empregados', '20 - 50 empregados', '50 - 250 empregados', '> 250 empregados'],
  en: ['< 5 employees', '5 - 20 employees', '20 - 50 employees', '50 - 250 employees', '> 250 employees'],
}

const windowSize = reactive({ width: 0, height: 0 })
function handleResize () {
  windowSize.width = window.innerWidth
  windowSize.height = window.innerHeight
}

// -------- reCAPTCHA v2 (checkbox) --------
const SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY
const rcDesktop = ref(null)
const rcMobile  = ref(null)
const rcIdDesktop = ref(null)
const rcIdMobile  = ref(null)
const rcVerified  = ref(false)
const rcToken     = ref('')

// honeypot/tempo mínimo (se quiseres enviar ao backend)
const hp = ref('')
const startedAt = ref(Math.floor(Date.now() / 1000))

function loadRecaptchaScript () {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha?.render) return resolve()
    const s = document.createElement('script')
    s.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=pt-PT'
    s.async = true
    s.defer = true
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
}

function onCaptchaSuccess (token) {
  rcToken.value = token
  rcVerified.value = true
}

function onCaptchaExpired () {
  rcVerified.value = false
  rcToken.value = ''
  try {
    if (rcIdDesktop.value !== null) window.grecaptcha.reset(rcIdDesktop.value)
    if (rcIdMobile.value  !== null) window.grecaptcha.reset(rcIdMobile.value)
  } catch (_) {}
}

function renderRecaptcha () {
  if (!SITE_KEY) {
    console.error('VUE_APP_RECAPTCHA_SITE_KEY em falta.')
    return
  }
  if (rcDesktop.value && rcIdDesktop.value === null) {
    rcIdDesktop.value = window.grecaptcha.render(rcDesktop.value, {
      sitekey: SITE_KEY,
      callback: onCaptchaSuccess,
      'expired-callback': onCaptchaExpired,
      theme: 'light',
      size: 'normal'
    })
  }
  if (rcMobile.value && rcIdMobile.value === null) {
    rcIdMobile.value = window.grecaptcha.render(rcMobile.value, {
      sitekey: SITE_KEY,
      callback: onCaptchaSuccess,
      'expired-callback': onCaptchaExpired
    })
  }
}

const recaptchaOk = computed(() => rcVerified.value && !!rcToken.value)
// -----------------------------------------

onMounted(async () => {
  loading.value = false
  handleResize()
  window.addEventListener('resize', handleResize)

  try {
    await loadRecaptchaScript()
    renderRecaptcha()
  } catch (e) {
    console.error('Falha ao carregar/renderizar reCAPTCHA:', e)
  }
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

const countries = computed(() => t('countries'))

async function submit () {
  try {
    // 1) garantir token do reCAPTCHA
    let token = ''
    try {
      if (rcIdDesktop.value !== null) token = window.grecaptcha.getResponse(rcIdDesktop.value) || ''
      if (!token && rcIdMobile.value !== null) token = window.grecaptcha.getResponse(rcIdMobile.value) || ''
    } catch (e) {console.log(e)}
    if (!token) {
      animated.value = true
      setTimeout(() => (animated.value = false), 1000)
      return
    }

    // 2) validações simples de campos
    if (!fields.name || !fields.email || !fields.description) {
      animated.value = true
      setTimeout(() => (animated.value = false), 1000)
      return
    }

    // 3) payload esperado pelo backend PHP
    const payload = {
      name: fields.name,
      email: fields.email,
      subject: fields.title || 'Mensagem do website',
      message: fields.description,
      company: fields.company,
      numero: fields.numero,
      country: fields.country,
      size: fields.size,
      'g-recaptcha-response': token, // <- IMPORTANTÍSSIMO
      website_hp: '',                 // honeypot tem de ir vazio
      started_at: startedAt.value,    // tempo mínimo
    }

    // 4) chamada ao backend
    await sendContact(payload)

    // 5) reset opcional do captcha
    try {
      if (rcIdDesktop.value !== null) window.grecaptcha.reset(rcIdDesktop.value)
      if (rcIdMobile.value  !== null) window.grecaptcha.reset(rcIdMobile.value)
    } catch (_) {}

    // 6) navegar para sucesso
    router.push('/' + String((globalThis.__i18n?.global?.locale ?? 'pt')) + '/success')
  } catch (err) {
    console.error(err)
    animated.value = true
    setTimeout(() => (animated.value = false), 1000)
  }
}

</script>

<style>
.top-image {
  background: url('../assets/covers/topo.svg') no-repeat;
  background-size: 100%;
  margin-top: -8%;
}
@media (max-width: 959px) {
  .top-image { margin-top: 0; }
}
.mobile-medium {
  position: absolute;
  bottom: 0;
  height: 100%;
  clip-path: polygon(16% 0, 100% 53%, 100% 75%, 6% 100%, 5% 100%);
  width: 100%;
}
.mobile-small {
  position: absolute;
  bottom: 0;
  height: 100%;
  clip-path: polygon(45% 0, 100% 53%, 100% 81%, 0 89%, 0 61%);
  width: 100%;
}
.blue-big-triangle { border: 60px solid transparent; position: absolute; border-bottom: 140px solid #052947; rotate: 200deg; z-index: 0; top: 0; right: 35vh; }
.white-big-triangle { border: 60px solid transparent; position: absolute; border-bottom: 140px solid white; rotate: -25deg; z-index: 0; top: 5vh; right: 15vh; }
.bellow-white { border: 30px solid transparent; position: absolute; border-bottom: 70px solid #063F57; rotate: 45deg; z-index: 0; top: 30vh; right: 0; }
.above-white { border: 20px solid transparent; position: absolute; border-bottom: 40px solid #0D1F2B; rotate: 45deg; z-index: 0; top: 1vh; right: 0; }
.orange-light-triangle { border: 30px solid transparent; position: relative; border-bottom: 70px solid #EF9576; rotate: -145deg; z-index: 0; top: -75vh; left: -37vh; }
.great-triangle { border: 250px solid transparent; border-bottom: 350px solid #052947; z-index: 0; }
.triangulo-cover { background: url('../assets/covers/triangulo.png') no-repeat; background-size: 100%; }
.small-darkblue-triangle { border: 30px solid transparent; position: absolute; border-bottom: 70px solid #0D1F2B; rotate: -80deg; z-index: 0; top: 0; right: 0; }
.second-small-darkblue-triangle { border: 35px solid transparent; position: absolute; border-bottom: 70px solid #0D1F2B; rotate: 135deg; z-index: 0; top: 10vh; right: 45vh; }
.orange-triangle { border: 50px solid transparent; position: relative; border-bottom: 100px solid #E76012; rotate: 20deg; z-index: 0; left: 30vh; }
.white-triangle { border: 90px solid transparent; position: relative; border-bottom: 140px solid #EAEAE9; rotate: 50deg; z-index: 0; bottom: 10vh; left: -20vh; }
.green-light-triangle { border: 25px solid transparent; position: relative; border-bottom: 80px solid #14545B; rotate: -10deg; z-index: 0; top: -100vh; left: -28vh; }
.shake { animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both; }
@keyframes shake {
  10%, 90% { transform: translate3d(-10px, 0, 0); }
  20%, 80% { transform: translate3d(12px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-16px, 0, 0); }
  40%, 60% { transform: translate3d(16px, 0, 0); }
}
</style>
